import { Component, OnInit, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormRecord } from '@angular/forms';
import { EnfantService } from './components/enfant/services/enfant.service';
import { EnfantForm, EnfantModel } from './components/enfant/models/enfant.model';
import { ConstantePage } from '../constants/constante-page';
import { TagWaService } from '../services/tag-wa.service';
import { SimulerService } from '../services/simuler.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-declaration-enfant',
  templateUrl: './declaration-enfant.component.html',
  styleUrls: ['./declaration-enfant.component.css']
})
export class DeclarationEnfantComponent implements OnInit, AfterContentChecked {

  pageName = ConstantePage.STATS_PAGE_DECLARATION_ENFANT;
  chapter3Page = ConstantePage.STATS_CHAPTER3_PAGE_DECLARATION;
  pagePrecedente = ConstantePage.STATS_PAGE_DECLARATION;
  
  nbEnfant: number;
  codePostal: string;
  enfants: Array<EnfantModel>;
  
  isPageErreur = false;

  sessionPagePrecedente: string;
  sessionPageCourante: string;

  pageForm : FormRecord<FormGroup<EnfantForm>>;

  /**
   * Constructor 
   * 
   * @param router 
   * @param enfantService 
   * @param tagWaService 
   */
  constructor(
    private readonly router: Router, 
    private readonly enfantService: EnfantService,
    private readonly tagWaService: TagWaService,
    private readonly cd: ChangeDetectorRef,
    private readonly simulerService: SimulerService
    ) {}

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.pageForm = new FormRecord<FormGroup<EnfantForm>>({});
    // On tague la page pour le WA
    this.tagWaService.tagPage(this.pageName, this.chapter3Page);
    
    // On récupère les infos saisie en session
    this.sessionPagePrecedente = sessionStorage.getItem(this.pagePrecedente);
    this.sessionPageCourante = sessionStorage.getItem(this.pageName);

    const jsonPagePrecedente = JSON.parse(this.sessionPagePrecedente);
    this.nbEnfant = jsonPagePrecedente.sitFam.nbEnfants;
    this.codePostal = jsonPagePrecedente.logement.localite.codePostal;
    this.enfants = this.enfantService.getListeEnfant(this.nbEnfant);
    
    // Si la page courante est trouvée en session on la ré affiche
    if ( this.sessionPageCourante != null ) {
      const jsonPageCourante  = JSON.parse(this.sessionPageCourante);
      this.enfants.forEach((element, index) => {
        if (jsonPageCourante[index]) {
          this.enfants[index] = jsonPageCourante[index];
        } else {
          this.enfants[index] = element;
        }        
      });
    }
  }  

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  /**
   * Click Précédent
   */
  clickPrecedent() {    
    // Mise en session de la page enfants
    sessionStorage.setItem(this.pageName, JSON.stringify(this.enfants));
    
    // Redirection
    this.router.navigate(['/declaration']);
  }

  /**
   * Click Suivant
   */
  async clickSuivant() {
    // Ajout des enfants dans la session declaration pour faciliter je sais pas quoi...
    const jsonPagePrecedente = JSON.parse(this.sessionPagePrecedente);
    jsonPagePrecedente.listeEnfants = this.enfants;
    
    // Mise en session de la page enfants
    sessionStorage.setItem(this.pagePrecedente, JSON.stringify(jsonPagePrecedente));
    
    if (environment.bouchon) {
      await this.simulerService.initBouchon();
    } else {
      await this.simulerService.initEcran();
    }   

    if (sessionStorage.getItem("erreurSimulateur")=="true") {
      this.isPageErreur = true;
    }
  }

  /**
   * Gestion du changement de valeur de enfant model
   * @param $event 
   * @param id 
   */
  dataEnfantChange($event : EnfantModel, id : number) : void {
    this.enfants[id] = $event;
  }
}
